<template>
  <div class="item d-flex align-items-center">
    <router-link
      class="d-flex align-items-center"
      :to="{ name: 'admin-user-single', params: { id: a.id } }"
    >
      <b-avatar variant="info" :text="initials"></b-avatar>
      <div class="name">
        <span v-if="a.last_name && a.first_name">
          {{ a.last_name }}
          {{ a.first_name }}
        </span>
        <div class="email">
          {{ a.email }}
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["a"],
  data() {
    return {};
  },
  computed: {
    initials() {
      let initials = "AB";
      if (this.a && this.a.first_name && this.a.last_name) {
        initials = this.a.last_name[0] + " " + this.a.first_name[0];
      }
      return initials;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 12px;
  margin-bottom: 12px;
  a {
    color: #000;
    text-decoration: none;
    line-height: 1;
  }
  .name {
    font-weight: 600;
    margin-left: 12px;
  }
  .email {
    color: var(--primary-color);
    font-size: 14px;
    opacity: 0.7;
    padding-top: 4px;
  }
}
</style>
